import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bibShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectEditionsForCurrentBib } from 'app/selectors/catalogBibs/ManifestationsSelector';
import EditionAndLanguage from './EditionAndLanguage';

export function EditionAndLanguageContainer(props) {
  return <EditionAndLanguage {...props} />;
}

EditionAndLanguageContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  editions: ImmutablePropTypes.listOf(bibShape).isRequired
};

const mapStateToProps = (state, ownProps) => ({
  catalogBib: ownProps.catalogBib || selectCatalogBib(state),
  editions: selectEditionsForCurrentBib(state)
});

export default connect(mapStateToProps)(EditionAndLanguageContainer);
